import { StatutoryCommitteeActions } from "./action";

const initialState = {
  StatutoryCommittee: [],
  StatutoryCommitteeSubpage: [],
};

export const StatutoryCommitteeReducer = (state = initialState, action) => {
  switch (action.type) {
    case StatutoryCommitteeActions.SET_STATUTORY_COMMITTEE:
      return {
        ...state,
        StatutoryCommittee: action.payload,
      };

    case StatutoryCommitteeActions.SET_STATUTORY_COMMITTEE_SUBPAGE:
      return {
        ...state,
        StatutoryCommitteeSubpage: action.payload,
      };

    default:
      return state;
  }
};


